export default __webpack_public_path__ + "static/media/Fauji-foundation.df3ce423.png";